import '../../App.css';
import Activities from '../Activities';
import Attractions from '../Attractions';
import LocationFull from '../LocationFull';
import Summary from '../Summary';


function Stay() {
  return (
    <>
      <Summary />
      <Attractions />
      <LocationFull />
    </>
  );
}

export default Stay;